import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import Root from './client_customizations/containers/Root/Root';
import LanguageParamRedirect from './components/LanguageParamRedirect/LanguageParamRedirect';
import useLanguage from './hooks/useLanguage';

const App = () => {
  const { language, locale, messages, changeLanguage } = useLanguage();

  return (
    <IntlProvider locale={locale.intlLocale} messages={messages}>
      <Router>
        <LanguageParamRedirect changeLanguage={changeLanguage} />
        <Root language={language} changeLanguage={changeLanguage} />
      </Router>
    </IntlProvider>
  );
};

export default App;
